import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import { UB_CLASS_ROOM_POST_ITEM_TYPE } from '@app/utils/itemTypeForAnalytics';
import {
  ReactionList,
  ReactionPicker,
} from '@components/presentational/ResponsiveReactions';

type PostReactionsProps = {
  postId: string;
  readOnly?: boolean;
};

const PostReactions = ({ postId, readOnly = false }: PostReactionsProps) => (
  <Box
    aria-label="Post reactions"
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      minHeight: '40px',
      minWidth: 0,
      width: '100%',
    }}
  >
    <ReactionList
      itemId={postId}
      itemType={UB_CLASS_ROOM_POST_ITEM_TYPE}
      readOnly={readOnly}
    />
    <ReactionPicker
      itemId={postId}
      itemType={UB_CLASS_ROOM_POST_ITEM_TYPE}
      readOnly={readOnly}
    />
  </Box>
);

export default PostReactions;
